import { highlightParts } from './searchModel';

/** Text with the query words marked. */
export function Highlight({ text, query }: { text: string; query: string }) {
  return (
    <>
      {highlightParts(text, query).map((part, i) => part.match
        ? <mark key={i} className="rounded-sm bg-gold-100 px-px text-inherit">{part.text}</mark>
        : <span key={i}>{part.text}</span>)}
    </>
  );
}
